module.exports = __webpack_public_path__ + "img/FotoMo5.0c7b41bc.png";